const MuiInputBase = {
  styleOverrides: {
    input: {
      height: '1.1876em',
    },
    root: {
      '& > span': {
        marginLeft: '4px',
        marginTop: '4px',
      },
      lineHeight: '1.1876em',
    },
  },
};

export default MuiInputBase;
